// ENV is generated in next.config.js stringified into an environment variable.
// This file should be imported by any file that uses ENV to ensure that ENV
// has been properly initialized
//
// @ts-ignore
global.ENV = JSON.parse(process.env.STRINGIFIED_ENV);
